import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { awsAllAccountsSelector } from "./awsAllAccountsSelector";
import { accountsSortBySelector } from "../slice-data/accountsSortBySelector";
import { accountsSortingCombiner } from "../../combiners/accountsSortingCombiner";

export const awsSortedAccountsSelector = createDraftSafeSelector(
  [awsAllAccountsSelector, accountsSortBySelector],
  accountsSortingCombiner,
);
